import type { OverlayTemplate } from 'klinecharts';

/** extendData shape for alertPriceLine */
export interface AlertPriceLineData {
  label: string;
}

const AMBER     = '#F59E0B';
const FONT_SIZE = 11;
const PAD_X     = 6;

const alertPriceLine: OverlayTemplate = {
  name: 'alertPriceLine',
  totalStep: 2,
  needDefaultPointFigure: false,
  needDefaultXAxisFigure: false,
  needDefaultYAxisFigure: false,

  // Only the dashed line on the chart canvas — no badge here
  createPointFigures: ({ coordinates, bounding }) => {
    if (coordinates.length < 1) return [];
    const y = coordinates[0].y;
    return [{
      type: 'line',
      ignoreEvent: true,
      attrs: {
        coordinates: [
          { x: 0, y },
          { x: bounding.width, y },
        ],
      },
      styles: {
        color: AMBER,
        style: 'dashed',
        dashedValue: [4, 3],
        size: 1,
      },
    }];
  },

  // Amber badge on the Y-axis using a single text figure with backgroundColor
  createYAxisFigures: ({ overlay, coordinates, bounding }) => {
    if (coordinates.length < 1) return [];

    const y     = coordinates[0].y;
    const w     = bounding.width;
    const raw   = overlay.extendData as AlertPriceLineData | null;
    const label = raw?.label ?? '';

    return [{
      type: 'text',
      ignoreEvent: true,
      attrs: {
        x: w,
        y,
        text: label,
        align: 'right',
        baseline: 'middle',
      },
      styles: {
        style: 'stroke_fill',
        color: '#000000',
        size: FONT_SIZE,
        family: 'sans-serif',
        weight: 'bold',
        backgroundColor: AMBER,
        borderColor: AMBER,
        borderSize: 0,
        borderRadius: 2,
        paddingLeft:   PAD_X,
        paddingRight:  PAD_X,
        paddingTop:    3,
        paddingBottom: 3,
      },
    }];
  },
};

export default alertPriceLine;

